import { User } from './auth';
import { Quote } from './quote';

export const PROJECT_STATUSES = ['in_progress', 'completed', 'cancelled'] as const;
export type ProjectStatus = (typeof PROJECT_STATUSES)[number];

export interface ProjectStatusChange {
  id: string;
  project_id: string;
  requested_by: User;
  current_status: ProjectStatus;
  requested_status: ProjectStatus;
  reason: string;
  status: 'pending' | 'approved' | 'rejected';
  created_at: string;
  updated_at: string;
}

export interface ProjectTask {
  id: string;
  name: string;
  description: string;
  hourly_rate: number;
  hours: number;
  total_amount: number;
  sort_order: number;
}

export interface ProjectAlliance {
  id: string;
  invited_freelancer_id: string;
  status: string;
  created_at: string;
  updated_at: string;
  child_quote?: {
    id: string;
    status: string;
    submitted_at: string;
    total_amount: number;
    tasks: ProjectTask[];
    quote_owner_id: string;
    quote_owner_first_name: string;
    quote_owner_last_name: string;
    quote_owner_avatar_url?: string;
    quote_owner_bio?: string;
    quote_owner_services: Array<{
      id: number;
      slug: string;
      label: string;
    }>;
  };
}

export interface Project {
  quote: Quote;
}

export interface ProjectStatusOption {
  id: ProjectStatus;
  label: string;
}
